import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';

const DeepLinkService = {
  getUrlByDeepLink: (data: object) =>
    trackPromise(
      api.post('/rest/deeplink/get/url/byDeeLink', JSON.stringify(data)),
    ),
  getDeepLinkApp: (data: object) =>
    trackPromise(
      api.post('/rest/deeplink/get/deeplink/forApp', JSON.stringify(data)),
    ),
};
export default DeepLinkService;
